var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:{'icon-only-btn': !_vm.label},attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"loading":_vm.loading,"disabled":!_vm.hasPerms(_vm.perms)},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.showLabel)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01084239","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Core/KtButton.vue
// module id = null
// module chunks = 